import { styled } from '@mui/material/styles'

const Divider = styled('hr')`
  border: 1px solid rgba(0, 0, 0, 0.1);
  width: 100%;
`

export { Divider }
